export const setCredentials = ({ token, user }) => ({
  type: 'SET_CREDENTIALS',
  payload: { token, user },
});
